module.exports = __webpack_public_path__ + "e0e5d480a51f5ecd53c3cf24cac8b0b8.png";